import React, { useEffect, useState } from 'react';
import { Card, Button, Table, Modal, Form, Row, Col } from 'react-bootstrap';
import { useConfig } from "../utils/ConfigContext.jsx";
import { createAxiosInstance } from "../utils/AxiosInstance.jsx";

// --- Role-Module Assignment Modal ---
// const AssignModulesModal = ({ show, handleClose, role, modules, onSave }) => {
//     const [selectedModuleIds, setSelectedModuleIds] = useState(role?.moduleIds || []);

//     useEffect(() => {
//         setSelectedModuleIds(role?.moduleIds || []);
//     }, [role]);

//     const handleCheckboxChange = (moduleId) => {
//         setSelectedModuleIds(prevIds =>
//             prevIds.includes(moduleId)
//                 ? prevIds.filter(id => id !== moduleId)
//                 : [...prevIds, moduleId]
//         );
//     };

//     const handleSave = () => {
//         onSave(role.id, selectedModuleIds);
//         handleClose();
//     };

//     return (
//         <Modal show={show} onHide={handleClose}>
//             <Modal.Header closeButton className="bg-info text-white">
//                 <Modal.Title>Assign Modules to: {role?.name}</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <Form>
//                     <div style={{ maxHeight: '300px', overflowY: 'auto', paddingRight: '10px' }}>
//                         {modules.map((module) => (
//                             <Form.Check
//                                 key={module.id}
//                                 type="checkbox"
//                                 id={`module-check-${module.id}`}
//                                 label={`${module.name} (${module.link})`}
//                                 checked={selectedModuleIds.includes(module.id)}
//                                 onChange={() => handleCheckboxChange(module.id)}
//                                 disabled={module.status === 'Inactive'}
//                                 className="mb-2"
//                             />
//                         ))}
//                     </div>
//                 </Form>
//             </Modal.Body>
//             <Modal.Footer>
//                 <Button variant="secondary" onClick={handleClose}>Close</Button>
//                 <Button variant="info" onClick={handleSave}>Save Assignments</Button>
//             </Modal.Footer>
//         </Modal>
//     );
// };



// --- Modules Card ---
const ModulesCard = ({ AxiosInstance }) => {
    const [modules, setModules] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [currentModule, setCurrentModule] = useState({});

    const getModules = async () => {
        try {
            const res = await AxiosInstance.get('/modules');

            setModules(res.data.data || []);
        } catch (error) {
            console.error("Error fetching modules:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getModules();
    }, []);

    const handleShow = (module = {}) => {
        setIsEditing(!!module.id);
        setCurrentModule(module);
        setShowModal(true);
    };
    const handleClose = () => setShowModal(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append("name", currentModule.name);
        formData.append("link", currentModule.link);
        formData.append("status", currentModule.status);
        if (currentModule.image instanceof File) {
            formData.append("image", currentModule.image);
        }

        if (isEditing) {
            await AxiosInstance.post(`/modules/${currentModule.id}?_method=PUT`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
        } else {
            await AxiosInstance.post("/modules", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
        }

        handleClose();
        getModules(); // Refresh list
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this module?')) return;
        try {
            await AxiosInstance.delete(`/modules/${id}`);
            setModules(modules.filter(m => m.id !== id));
        } catch (error) {
            console.error("Error deleting module:", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCurrentModule(prev => ({ ...prev, [name]: value }));
    };

    if (loading) return <p>Loading modules...</p>;

    return (
        <Card className="shadow-sm">
            <Card.Header className="d-flex justify-content-between align-items-center  text-white">
                <h5 className="mb-0">Module List</h5>
                <Button variant="light bg-success text-white" onClick={() => handleShow()}>
                    <i className="ri-add-circle-line me-2"></i> Add New Module
                </Button>
            </Card.Header>
            <Card.Body>
                <Table striped bordered hover responsive size="sm">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Link</th>
                            <th>Image/Icon</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {modules.map((module) => (
                            <tr key={module.mm_id}>
                                <td>{module.mm_module_name}</td>
                                <td><code>{module.mm_homepage_link}</code></td>
                                <td>
                                    <img src={module.mm_icon} alt={module.name} width={24} height={24} />
                                </td>
                                <td>
                                    <span className={`badge ${module.mm_module_status === 1 ? 'bg-success' : 'bg-danger'}`}>
                                        {module.mm_module_status === 1 ? 'Active' : 'Inactive'}
                                    </span>
                                </td>
                                <td>
                                    <Button variant="outline-primary" size="sm" className="me-2" onClick={() => handleShow(module)}>
                                        <i className="ri-edit-line"></i>
                                    </Button>
                                    <Button variant="outline-danger" size="sm" onClick={() => handleDelete(module.id)}>
                                        <i className="ri-delete-bin-line"></i>
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>

                {/* Add/Edit Modal */}
                <Modal show={showModal} onHide={handleClose}>
                    <Modal.Header closeButton className="bg-success text-white">
                        <Modal.Title>{isEditing ? 'Edit Module' : 'Add New Module'}</Modal.Title>
                    </Modal.Header>

                    <Form onSubmit={handleSubmit} encType="multipart/form-data">
                        <Modal.Body>
                            <Form.Group className="mb-3">
                                <Form.Label>Module Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    value={currentModule.name || ''}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Link (Route)</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="link"
                                    value={currentModule.link || ''}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>

                            <Row>
                                <Col>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Image/Icon</Form.Label>
                                        <Form.Control
                                            type="file"
                                            name="image"
                                            accept="image/*"
                                            onChange={(e) =>
                                                setCurrentModule({
                                                    ...currentModule,
                                                    image: e.target.files[0],
                                                })
                                            }
                                        />

                                        {/* Preview selected image */}
                                        {currentModule.image && (
                                            <div className="mt-2">
                                                <img
                                                    src={
                                                        typeof currentModule.image === "string"
                                                            ? currentModule.image
                                                            : URL.createObjectURL(currentModule.image)
                                                    }
                                                    alt="preview"
                                                    style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "6px" }}
                                                />
                                            </div>
                                        )}
                                    </Form.Group>
                                </Col>

                                <Col>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Status</Form.Label>
                                        <Form.Select
                                            name="status"
                                            value={currentModule.status || ''}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Modal.Body>

                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>Close</Button>
                            <Button variant="success" type="submit">
                                {isEditing ? 'Save Changes' : 'Create Module'}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            </Card.Body>
        </Card>
    );
};

// --- Main Page ---
const Modules = () => {
    const { API_BASE_URL } = useConfig();
    const AxiosInstance = createAxiosInstance(API_BASE_URL);

    return (
        <>
            <style>{`
                .modal-backdrop {
                    height: 100% !important;
                    width: 100% !important;
                }
            `}</style>

            <div className="py-4">
                <Row className="g-4">

                    <Col lg={12}>
                        <ModulesCard AxiosInstance={AxiosInstance} />
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default Modules;
